import { env } from "@repo/design-system/setup/env";
import { z } from "zod";

export const validateSubclientString = z
  .string()
  .nullable()
  .optional()
  .transform((v) => (v === env.CLIENT || !v ? undefined : v));

export const filterSearchParamsSchema = z.object({
  searchQuery: z.string(),
  filter: z.record(z.string(), z.array(z.string())),
  geoLocation: z
    .object({
      name: z.string(),
      lat: z.number(),
      lng: z.number(),
      placeId: z.string().optional(),
    })
    .optional(),
  boundaries: z
    .object({
      coordinates: z.array(z.array(z.tuple([z.number(), z.number()]))),
      placeId: z.string(),
    })
    .optional(),
  radius: z
    .object({
      value: z.number(),
      label: z.string(),
    })
    .optional(),
  postingDateFilter: z.string().optional(),
  subclient: validateSubclientString,
  pageSize: z.coerce.number().int().min(1).max(50).optional(),
});

export const filterSearchSchema = z.object({
  searchQuery: z.string(),
  locale: z.string(),
  page: z.coerce.number().default(0),
  filter: z.record(z.string(), z.array(z.string())),
  geoLocation: z
    .object({
      name: z.string(),
      lat: z.number(),
      lng: z.number(),
      placeId: z.string().optional(),
    })
    .optional(),
  boundaries: z
    .object({
      coordinates: z.array(z.array(z.tuple([z.number(), z.number()]))),
      placeId: z.string(),
    })
    .optional(),
  radius: z
    .object({
      value: z.number(),
      label: z.string(),
    })
    .optional(),
  postingDateFilter: z.string().optional(),
  subclient: validateSubclientString,
  pageSize: z.coerce.number().int().min(1).max(50).optional(),
});
